import React, { useState, useEffect } from "react";
import { Box, Typography } from "@mui/material";
import SelectField from "../../../Components/Masters/SelectField";

export const monthlist = [
  { id: 1, month: "Jan" },
  { id: 2, month: "Feb" },
  { id: 3, month: "Mar" },
  { id: 4, month: "Apr" },
  { id: 5, month: "May" },
  { id: 6, month: "Jun" },
  { id: 7, month: "Jul" },
  { id: 8, month: "Aug" },
  { id: 9, month: "Sep" },
  { id: 10, month: "Oct" },
  { id: 11, month: "Nov" },
  { id: 12, month: "Dec" },
];

const currentYear = new Date().getFullYear();
const currentMonth = new Date().getMonth(); // Current month (0-based, January = 0)
const startYear = currentYear - 5; // 5 years ago from the current year
const years = Array.from({ length: 6 }, (_, i) => startYear + i); // 6 years range (from 5 years ago to the current year)

const MonthYearPicker = ({
  name,
  title,
  errors,
  setErrors,
  selectedMonth,
  setSelectedMonth,
  selectedYear,
  setSelectedYear,
  defaultMonth = currentMonth,
  defaultYear = currentYear,
  width,
  gap,
}) => {
  const [filteredYears, setFilteredYears] = useState(years);
  const [disableValue, setDisableValue] = useState("");

  useEffect(() => {
    setSelectedMonth(defaultMonth);
    setSelectedYear(defaultYear);
  }, [defaultMonth, defaultYear]);

  // Handle Month and Year Change
  const handleMonthChange = (event) => {
    setDisableValue("");
    setErrors && setErrors({ ...errors, month: "", consumptionMonth: "" });
    const selectedMonthIndex = event.target.value;
    console.log(
      "month",
      monthlist[selectedMonthIndex],
      selectedMonthIndex,
      currentMonth + 1
    );
    // setFormData({
    //   ...formData,
    //   consumptionPeriod: {
    //     ...formData.consumptionPeriod,
    //     month: selectedMonthIndex, // Update the 'year' field within 'consumptionPeriod'
    //   },
    // }); // Set the month index
    setSelectedMonth(selectedMonthIndex);
    if (selectedMonthIndex >= currentMonth + 1) {
      setDisableValue(currentYear);
      setSelectedYear("");
    }
    // setFilteredYears(selectedMonthIndex > currentMonth ? years.slice(0, years.length - 1) : years);
  };

  const handleYearChange = (event) => {
    setErrors && setErrors({ ...errors, year: "", consumptionMonth: "" });
    setSelectedYear(event.target.value);
  };

  return (
    <Box>
      {title && (
        <Typography variant="subtitle1" sx={{ fontWeight: "bold" }}>
          {title}
        </Typography>
      )}
      <Box sx={{ display: "flex", gap: gap || 1 }}>
        <Box sx={{ minWidth: "48%" }}>
          <SelectField
            name={name}
            value={selectedMonth}
            handleChange={handleMonthChange}
            label="Month"
            field="month"
            errors={errors?.["month"] || ""}
            defaultValue={"Month"}
            options={monthlist} // Month options as strings
          />
        </Box>

        {/* Year Input */}
        <Box sx={{ minWidth: "48%" }}>
          <SelectField
            name={name}
            value={selectedYear}
            handleChange={handleYearChange}
            options={filteredYears}
            errors={errors?.["year"] || ""}
            defaultValue={"Year"}
            menuDisable={disableValue}
          />
        </Box>
      </Box>
    </Box>
  );
};

export default MonthYearPicker;
